// Per-Source favicon resolved through Google's s2/favicons service.
// "Source" here is the brand id carried on Work.source / Provider.source
// (e.g. "ko-fi", "gumroad", "xivmodarchive"). Display metadata is looked
// up from the static source registry.

import { useState } from 'preact/hooks';
import { resolveSource } from '../api/sourceRegistry';

export function SourceFavicon({
  source,
  size = 16,
  title,
}: {
  /** Brand id (e.g. <c>"ko-fi"</c>). Resolved via <c>sourceRegistry</c>. */
  source?: string | null;
  size?: number;
  title?: string;
}) {
  const [errored, setErrored] = useState(false);
  const meta = resolveSource(source);
  const titleText = title ?? meta.name;

  if (!meta.domain || errored) {
    return (
      <span
        title={titleText}
        class={`inline-block shrink-0 grid place-items-center rounded-sm font-mono text-[10px] text-surface-base ${meta.color}`}
        style={{ width: `${size}px`, height: `${size}px` }}
      >
        {(meta.name[0] ?? '?').toUpperCase()}
      </span>
    );
  }

  const url = `https://www.google.com/s2/favicons?domain=${encodeURIComponent(meta.domain)}&sz=64`;
  return (
    <img
      src={url}
      alt=""
      title={titleText}
      width={size}
      height={size}
      onError={() => setErrored(true)}
      class="inline-block shrink-0 rounded-sm"
      loading="lazy"
    />
  );
}
